// import { SecureRoute } from "@okta/okta-react";
import { Route } from "react-router-dom"
import RouteGuard from "auth/RouteGuard"
import { default as PageComponent } from "components/common/layout/Page"
import React from "react"
class Page {
  constructor({
    title,
    route,
    component,
    tooltipHeading,
    tooltipText,
    navIcon = null,
    showTitle = true,
    routeIsExact = true,
    hidePageOnSideBar = false,
    enableForAllProjects = false,
    portalComponentKey
  }) {
    Object.defineProperty(this, "title", {
      value: title,
      enumerable: false,
      configurable: false,
      writable: false
    })
    Object.defineProperty(this, "tooltipHeading", {
      value: tooltipHeading,
      enumerable: false,
      configurable: false,
      writable: false
    })
    Object.defineProperty(this, "tooltipText", {
      value: tooltipText,
      enumerable: false,
      configurable: false,
      writable: false
    })
    Object.defineProperty(this, "showTitle", {
      value: showTitle,
      enumerable: false
    })
    Object.defineProperty(this, "_component", {
      value: component,
      writable: false,
      configurable: false,
      enumerable: false
    })
    Object.defineProperty(this, "route", {
      value: route,
      enumerable: false,
      configurable: false,
      writable: false
    })
    Object.defineProperty(this, "routeIsExact", {
      value: routeIsExact,
      writable: false,
      configurable: false,
      enumerable: false
    })
    Object.defineProperty(this, "hidePageOnSideBar", {
      value: hidePageOnSideBar,
      writable: false,
      configurable: false,
      enumerable: false
    })
    Object.defineProperty(this, "enableForAllProjects", {
      value: enableForAllProjects,
      writable: false,
      configurable: false,
      enumerable: false
    })
    Object.defineProperty(this, "portalComponentKey", {
      value: portalComponentKey,
      writable: false,
      configurable: false,
      enumerable: false
    })
    Object.defineProperty(this, navIcon, {
      value: navIcon,
      enumerable: false,
      configurable: false,
      writable: false
    })
  }
  get Component() {
    return (
      <PageComponent
        title={this.showTitle ? this.title : null}
        tooltipHeading={this.tooltipHeading}
        tooltipText={this.tooltipText}
      >
        {React.createElement(this._component, {}, [])}
      </PageComponent>
    )
  }
}

class Module {
  constructor({
    name,
    route,
    pages,
    navIcon = null,
    navBarSection = null,
    collapsibleOnSideNavBar = false
  }) {
    Object.defineProperty(this, "name", {
      value: name,
      writable: false,
      configurable: false,
      enumerable: false
    })
    Object.defineProperty(this, "route", {
      value: route,
      writable: false,
      configurable: false,
      enumerable: false
    })
    Object.defineProperty(this, "_registerKey", {
      value: Symbol("registerKey"),
      enumerable: false,
      configurable: false,
      writable: false
    })
    Object.defineProperty(this, this._registerKey, {
      value: new PageRegistry(pages),
      enumerable: false,
      configurable: false,
      writable: false
    })
    Object.defineProperty(this, "navIcon", {
      value: navIcon,
      enumerable: false,
      configurable: false,
      writable: false
    })
    Object.defineProperty(this, "navBarSection", {
      value: navBarSection,
      enumerable: false,
      configurable: false,
      writable: false
    })
    Object.defineProperty(this, "collapsibleOnSideNavBar", {
      value: collapsibleOnSideNavBar,
      writable: false,
      configurable: false,
      enumerable: false
    })
  }
  get routes() {
    const pages = this[this._registerKey].register
    return pages.map((page) => {
      const route = `${this.route}${page.route}`
      return (
        <Route
          key={route}
          path={route}
          exact={page.routeIsExact}
          component={() => (
            <RouteGuard
              enableForAllProjects={page.enableForAllProjects}
              sectionName={this.navBarSection}
              portalComponentKey={page.portalComponentKey}
            >
              {page.Component}
            </RouteGuard>
          )}
        />
      )
    })
  }
  get nav() {
    const pages = this[this._registerKey].register
    return {
      name: this.name,
      links: pages.map((page) => {
        return {
          name: page.title,
          url: `${this.route}${page.route}`,
          hidePageOnSideBar: page.hidePageOnSideBar,
          enableForAllProjects: page.enableForAllProjects,
          portalComponentKey: page.portalComponentKey
        }
      }),
      url: this.route,
      icon: this.navIcon,
      collapsibleOnSideNavBar: this.collapsibleOnSideNavBar
    }
  }
}
class PageRegistry {
  _registry = []
  constructor(pages) {
    for (const page of pages) {
      this.registerPage(page)
    }
  }
  registerPage(page) {
    if (!page instanceof Page)
      throw Error(
        `Cannot register item: ${page} because it is not a Page object.`
      )
    this._registry.push(page)
  }
  get register() {
    return this._registry
  }
  set register(_) {
    throw Error("Cannot edit registry.")
  }
}

class ModuleRegistry {
  _registry = []
  _routes = []
  _nav = {}
  contstructor(modules) {
    for (const module of modules) {
      this.registerModule(module)
    }
  }
  registerModule(module) {
    if (!module instanceof Module)
      throw Error(
        `Cannot register item: ${module} because it is not a Module object.`
      )
    this._registry.push(module)
    this._routes.push(...module.routes)
    if (module.navBarSection) {
      if (module.navBarSection in this._nav) {
        this._nav[module.navBarSection].push(module.nav)
      } else {
        this._nav[module.navBarSection] = [module.nav]
      }
    }
    // this._nav.push(module.nav)
  }

  get routes() {
    return this._routes
  }
  get nav() {
    return this._nav
  }
}
class PortalExtension {
  constructor({ environments, modules, store }) {
    Object.defineProperty(this, "environments", {
      value: environments,
      writable: false,
      configurable: false,
      enumerable: false
    })
    Object.defineProperty(this, "modules", {
      value: modules,
      enumerable: false,
      configurable: false,
      writable: false
    })
    Object.defineProperty(this, "store", {
      value: store,
      enumerable: false,
      configurable: false,
      writable: false
    })
  }
  registerModule(module) {
    this.modules.push(module)
  }
}

const navBarSections = Object.freeze({
  adminSection: "Admin",
  cmsSection: "CMS",
  clientSection: "Client"
})

const navBarViews = Object.freeze({
  internalView: "Internal",
  clientView: "Client"
})

export {
  PageRegistry,
  ModuleRegistry,
  Module,
  Page,
  PortalExtension,
  navBarSections,
  navBarViews
}
